import { BaseAvatarCell } from "./BaseAvatarCell";
import type { Employee } from "@/types/employee";

interface EmployeeAvatarCellProps {
  employee: Employee;
  onClick: () => void;
}

/**
 * Avatar cell component for employees table that handles avatarUrl field
 * Resolves image IDs to URLs using the image service when needed
 * Supports both UUID image IDs and direct URLs (http/https/data/blob/relative paths)
 */
export function EmployeeAvatarCell({ employee, onClick }: EmployeeAvatarCellProps) {
  return <BaseAvatarCell entity={employee} onClick={onClick} />;
}